export interface MobileInstallEntryVisibility {
  isMobile: boolean;
  canShowInstallEntry: boolean;
}

export const shouldShowMobileInstallEntry = ({
  isMobile,
  canShowInstallEntry,
}: MobileInstallEntryVisibility): boolean => isMobile && canShowInstallEntry;
